import React from 'react';
import RoleAssignStyles from '../RoleAssign.module.scss';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Tooltip from '@material-ui/core/Tooltip';
import TableSwitch from '../Component/TableSwitch';
import { makeStyles } from '@material-ui/styles';
import { manualHeaderId } from '../constant';
import { permissionsDescription } from '../../../constants/permissions';

const textStyles = makeStyles(theme => ({
  customTooltip: {
    fontSize: '14px'
  }
}));

function RoleAssignTable(props) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    emptyList,
    permissionData,
    value,
    changeSwitchState
  } = props;

  const classes = textStyles();

  return (
    <>
      <table {...getTableProps()} className={RoleAssignStyles.tableClass}>
        <thead>
          {headerGroups.map(headerGroup => (
            <>
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <>
                    {column.id === manualHeaderId && (
                      <th
                        {...column.getHeaderProps()}
                        className={RoleAssignStyles.customHeaderCell}
                      >
                        <th className={RoleAssignStyles.customHeader}>
                          Feature
                          <span className={RoleAssignStyles.arrowIconHeader}>
                            <ArrowDownwardIcon />
                          </span>
                        </th>
                        <th
                          className={RoleAssignStyles.customHeader}
                          style={{ border: 'none' }}
                        >
                          Role
                          <span className={RoleAssignStyles.arrowIconHeader}>
                            <ArrowForwardIcon />
                          </span>
                        </th>
                      </th>
                    )}
                    {column.id !== manualHeaderId && (
                      <td
                        {...column.getHeaderProps()}
                        className={RoleAssignStyles.headerRole}
                      >
                        <Tooltip
                          title={column.render('name')}
                          arrow
                          placement="top"
                          classes={{
                            tooltip: classes.customTooltip
                          }}
                        >
                          <div className={RoleAssignStyles.headerRoleList}>
                            {column.render('name')}
                          </div>
                        </Tooltip>
                      </td>
                    )}
                  </>
                ))}

                {emptyList.emptyListData.length > 0 &&
                  emptyList.emptyListData.map((value, index) => (
                    <td key={index} className={RoleAssignStyles.emptyCell}></td>
                  ))}
              </tr>
            </>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, i) => {
                  return (
                    <>
                      {cell.column.id === manualHeaderId && (
                        <td
                          {...cell.getCellProps()}
                          key={i}
                          className={RoleAssignStyles.featureList}
                        >
                          <Tooltip
                            title={
                              permissionsDescription[cell.value] ||
                              'It is the feature'
                            }
                            arrow
                            placement="right-end"
                            classes={{
                              tooltip: classes.customTooltip
                            }}
                          >
                            <div className={RoleAssignStyles.feature}>
                              {cell.render('Cell')}
                            </div>
                          </Tooltip>
                        </td>
                      )}

                      {cell.column.id !== manualHeaderId && (
                        <td
                          {...cell.getCellProps()}
                          key={i}
                          className={RoleAssignStyles.switchCell}
                        >
                          <>
                            {permissionData.permissionDataList.length > 0 && (
                              <TableSwitch
                                role={cell.column.name}
                                feature={cell.row.original.feature}
                                currentData={permissionData.permissionDataList}
                                changeSwitchState={changeSwitchState}
                                currentModule={value.currentModule}
                              />
                            )}
                          </>
                        </td>
                      )}
                    </>
                  );
                })}
                {emptyList.emptyListData.length > 0 &&
                  emptyList.emptyListData.map((value, index) => (
                    <td key={index} className={RoleAssignStyles.emptyCell}></td>
                  ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}

export default RoleAssignTable;
